import z from "zod";
export const PropsInputSchema = z.discriminatedUnion("kind", [
    z.strictObject({
        kind: z.literal("Props2Bool"),
        key: z.string(),
        value: z.boolean().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2Number"),
        key: z.string(),
        value: z.number().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2NumberArray"),
        key: z.string(),
        value: z.number().array().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2Text"),
        key: z.string(),
        value: z.string().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2TextArray"),
        key: z.string(),
        value: z.string().array().nullable(),
    }),
]);
//# sourceMappingURL=props2.js.map